import _ from "lodash";
import { useEffect, useState } from "react";
import HeaderFilter from "../components/HeaderFilter";
import ListCheck from "../components/ListCheck";
import ListDate from "../components/ListDate";

const GrowSecondaryFilter = (props) => {
  const {
    status,
    branches,
    properties,
    setFilterType,
    setDate,
    onSubmit,
    date,
  } = props;
  const [showDate, setShowDate] = useState(false);
  const [statusList, setListStatus] = useState([]);
  const [showFilter, setShowFilter] = useState({
    productType: false,
    propertyType: false,
    branch: false,
  });

  const LABLE = (status) =>
    _.get(
      {
        WAITING: "Chờ duyệt",
        SELLING: "Đang bán",
        SOLD: "Đã bán",
        HIDDEN: "Đã ẩn",
        LOCKED: "Đã khóa",
        ALL: "Xem tất cả",
      },
      status,
      ""
    );
  useEffect(() => {
    setListStatus(
      Object.keys(status)
        ?.map((item) => {
          return {
            id: item !== "all" && _.toUpper(item.toString()),
            name: item !== "all" && LABLE(item.toUpperCase()),
          };
        })
        .filter((item) => Boolean(item.id))
    );
  }, [status]);

  return (
    <HeaderFilter
      onSubmit={onSubmit}
      title="Mức độ tăng trưởng nguồn hàng thứ cấp"
    >
      <ListDate
        open={showDate}
        date={date}
        setDate={setDate}
        setOpen={setShowDate}
      />
      <ListCheck
        headerTitle="Trạng thái"
        data={statusList}
        open={showFilter.productType}
        setOpen={setShowFilter}
        field="productType"
        setFilterType={setFilterType}
        checkAllTitle="Chọn tất cả trạng thái"
      />
      <ListCheck
        headerTitle="Loại hình"
        data={properties}
        open={showFilter.propertyType}
        setOpen={setShowFilter}
        field="propertyType"
        setFilterType={setFilterType}
        checkAllTitle="Chọn tất cả loại hình"
      />
      <ListCheck
        headerTitle="Chi nhánh"
        data={branches}
        open={showFilter.branch}
        setOpen={setShowFilter}
        field="branch"
        setFilterType={setFilterType}
        checkAllTitle="Chọn tất cả chi nhánh"
      />
    </HeaderFilter>
  );
};

export default GrowSecondaryFilter;
